(function (angular) {
    angular.module('bizPartEngage').service('core.mynotes.service', myNotesService);

    myNotesService.$inject = ["$http"];

    function myNotesService($http) {
    	var apiPath = siteRootPath + "api/mynotes/";
    	var settingsPromise = [];

    	return {
    		ClearPromiseCache: ClearPromiseCache,
            GetMyNotes: GetMyNotes,
            SaveMyNotes: SaveMyNotes,
            SaveMyNote: SaveMyNote
        };

    	function ClearPromiseCache() {
    		settingsPromise = [];
    	}


    	function GetMyNotes(limit, startTime, endTime, force) {
            var key = "MY_NOTES";
    		if (!force && settingsPromise[key]) return settingsPromise[key];

    		settingsPromise[key] = $http.get(apiPath + 'GetMyNotes?' + $.param({limit: limit, startTime: moment(startTime).format(), endTime: moment(endTime).format()}));
    		return settingsPromise[key];
        }
        
        function SaveMyNotes(notes) {
            return $http.post(apiPath + "SaveMyNotes", notes);
        }

        function SaveMyNote(note) {
            return $http.post(apiPath + "SaveMyNote", note);
        }
    }
})(window.angular);
